import { useEffect } from "react";

import { useCoralCommentsContext } from "@voxmedia/duet-context/context/coral-comments-context";
import { useCoralPreviewOverride } from "src/context/CoralPreviewOverrideContext";
import { CORAL_PREVIEW_COMMENT_COUNT } from "src/utils/comments-preview";

/**
 * CSK comment count side effects: re-register when `coralId` changes and seed a
 * dev fallback for the staging preview thread. Use alongside `CommentCount`.
 */
export function useCskCommentCount(coralId: string | undefined): void {
  const previewOverride = useCoralPreviewOverride();
  const { registerCountId, updateCommentCount, getCommentCount } =
    useCoralCommentsContext();

  useEffect(() => {
    if (!coralId) {
      return;
    }
    registerCountId(coralId);
  }, [coralId, registerCountId]);

  useEffect(() => {
    if (!coralId || process.env.NODE_ENV !== "development") {
      return;
    }
    if (previewOverride?.storyId !== coralId) {
      return;
    }
    if (getCommentCount(coralId) !== null) {
      return;
    }
    updateCommentCount(coralId, CORAL_PREVIEW_COMMENT_COUNT, Date.now());
  }, [coralId, getCommentCount, previewOverride?.storyId, updateCommentCount]);
}
